import { Pipe, PipeTransform } from "@angular/core";

import { OrderItemResponse } from '../../models/order/order-response.model'

@Pipe({
    name: 'orderItemResponseValue',
    pure: false
})
export class OrderItemResponseValuePipe implements PipeTransform {

    transform(item: OrderItemResponse): number {
        let total: number = 0
        item.pedidoItemOpcoes.forEach(opt => total += (opt.valor * opt.quantidade))
        item.pedidoMeioMeios.forEach(half => total += half.valor)
        total += (item.produto.valorPromocao || item.produto.valorVenda) * item.quantidade
        return total
    }
}